import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MachineDetailsCompactDTO } from '../../../../../common/models/MachineDetailsCompactDTO';

@Component({
    selector: 'machines-stats-bar-chart-tooltip',
    templateUrl: './machines-stats-bar-chart-tooltip.component.html',
    styleUrls: ['./machines-stats-bar-chart-tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MachinesStatsBarChartTooltipComponent {

  @Input()
  model: MachineDetailsCompactDTO;

  constructor() { }

}
